import styles from './box.module.sass';
import cn from 'classnames';
import withResponsiveStyles, {
    ResponsiveValue,
    ResponsiveTheme,
    ResponsiveBorder,
} from '../hocs/ResponiseStyles/withResponsiveStyles';

interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    padding?: '0' | '2x' | '3x' | ResponsiveValue;
    theme?: 'light' | 'dark' | 'none' | ResponsiveTheme;
    sticky?: 'bottom' | 'top';
    border?: ResponsiveBorder;
}

const OriginalBox = ({ children, padding, theme, sticky, border, className, ...props }: BoxProps) => {
    const boxClasses = cn(
        styles.box,
        typeof padding === 'string' && styles['padding' + padding],
        typeof theme === 'string' && styles[theme],
        sticky && cn(styles.sticky, styles[sticky]),
        className
    );

    return (
        <div className={cn(boxClasses, props.onClick && styles.hovered)} {...props}>
            {children}
        </div>
    );
};

const Box = withResponsiveStyles(OriginalBox);
// Export the enhanced components
export { Box };
